import store from "../store";
import * as actions from "../actions";
import designService from "../service/designService";

export function markAsModified() {
  store.dispatch(actions.setLastUpdate(new Date().getTime()));

  if (store.getState().isTemplate || store.getState().hasChanges) return;
  store.dispatch(actions.markAsModified());

  designService.markAsModified(store.getState().designId, store.getState().lastSavedTag)
}
